<template>

    <div id="add-cost-field" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title mb-2" id="exampleModalCenterTitle">Nuovo costo nome</h5>
                    <button type="button" class="btn btn-xs btn-icon btn-ghost-secondary" data-dismiss="modal" aria-label="Close">
                        <i class="tio-clear tio-lg"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label>Nome</label>
                        <input class="form-control" type="text" v-model="label" />
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-white" data-dismiss="modal">Chiudi</button>
                    <button type="button" class="btn btn-primary" @click="addFieldEvent($event)" :disabled="label === ''">Salva</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Label from "@/Jetstream/Label";

export default {

    props: ['category'],

    components: {Label},

    data() {
        return {
            label: ''
        }
    },

    methods: {
        addFieldEvent(event) {
            this.$emit('add-field', {label: this.label, amount: 0}, this.category);
        }
    }
}

</script>
